import React from 'react';
import { ROLE } from '../../../../shared/constants/common';

/**
 * Warning shown when the user cannot send messages (e.g. must subscribe to creator).
 * Uses creatorInfo.rol for role-based messaging when needed.
 */
const ChatComposerRestrictedWarning = ({ creatorInfo }) => {
  const rol = creatorInfo?.rol;

  return (
    <div className="chat_composer_restricted_warning" role="alert" aria-live="polite">
      <i className="fa-solid fa-lock"></i>
      <span>
        {rol === ROLE.CREATOR_SUB
          ? 'Subscribe to unlock the chat.'
          : 'Follow to unlock the chat.'}

      </span>
    </div>
  );
};

export default React.memo(ChatComposerRestrictedWarning);
